// src/stores/modals.js
import { defineStore } from 'pinia'
import { Notify } from 'quasar'

export const useModalsStore = defineStore('modals', {
  state: () => ({
    aiTutorModal: false,
    activityLeaderboardModal: false,
    chatModal: false,
    checkoutModal: false,
    contractModal: false,
    forumRulesModal: false,
    helpModal: false,
    howToEarnModal: false,
    loginModal: false,
    membersOnlyModal: false,
    packEditModal: false,
    packInfoModal: false,
    pillInfoModal: false,
    pillViewModal: false,
    pillEditModal: false,
    pillShareModal: false,
    prescriptionViewModal: false,
    rewardModal: true, // default true
    tutorialModal: false,
    userModalEdit: false,
    userNameModal: false,
    userPrefsModal: false,
    userViewModal: false,
    widgetsModal: false,
  }),

  actions: {
  },
})
